import { render, staticRenderFns } from "./expertMatchingExpertList.vue?vue&type=template&id=45bc213a&"
import script from "./expertMatchingExpertList.vue?vue&type=script&lang=js&"
export * from "./expertMatchingExpertList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports